module.exports = "/_next/static/images/bone-72f8f1deae1813ecff308b98e765d18f.svg";